// extracted by mini-css-extract-plugin
export default {"spinner":"ButtonSpinner_spinner__CyfQ8","btnspin":"ButtonSpinner_btnspin__cM+H-"};